exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu_wrapper[data-v-507a06a9]{width:400px;height:400px;overflow:auto;border:1px solid #eeeeee;padding:10px}\n", ""]);

// exports
